import React from "react";
import styled from "styled-components";
import CheckIcon from "svg/check-large.svg";

const mapColorValues = {
    ORANJE: ["#ff7500", "#fff"],
    ROOD: ["#e53935", "#fff"],
    WIT: ["#fff", "#000"],
    BLAUW: ["#1976d2", "#fff"],
    ROZE: ["#ec407a", "#fff"],
    GROEN: ["#38a614", "#fff"],
    GEEL: ["#f7c81e", "#000"],
    GRIJS: ["#e0e0e0", "#000"],
    BRUIN: ["#994200", "#fff"],
    BEIGE: ["#dcc5a4", "#000"],
    CREME: ["#f6e8cc", "#000"],
    PAARS: ["#ab47bc", "#fff"],
    ZWART: ["#000", "#fff"],
    GOUD: ["linear-gradient(#f6e58c, #dbac0d)", "#000"],
    ZILVER: ["linear-gradient(#f4f4f4, #b0aeaf)", "#000"],
    DIVERS: ["#fff", "#000"]
};

const CheckBoxContainer = styled.div`
    display: block;
    width: ${({ size = 16 }) => `${size}px`};
    height: ${({ size = 16 }) => `${size}px`};
    border: 1px solid
        ${({ checked, color, theme }) =>
            checked ? color || theme.colors.secondary[700] : theme.colors.breathing};
    background: ${({ checked, color, theme }) =>
        checked ? color || theme.colors.secondary[700] : color || "#fff"};
    color: ${({ checked, checkColor }) => (checked ? checkColor : "transparent")};
    margin: 0 8px 0 0;
    position: relative;
    transition: border-color 300ms;

    &:hover {
        border-color: ${({ theme }) => theme.colors.secondary[700]};
    }
`;

const StyledCheckIcon = styled(CheckIcon)`
    position: absolute;
    width: 120%;
    height: 120%;
    margin-top: -10%;
    margin-left: -10%;
`;

const Input = styled.input`
    visibility: hidden;
    position: absolute;
`;

export const CheckBox = ({ name, value, checked, onChange, size = 16 }) => {
    const [color, checkColor] = mapColorValues[value] || ["", "#fff"];
    return (
        <CheckBoxContainer checked={checked} size={size} color={color} checkColor={checkColor}>
            <Input
                type="checkbox"
                name={name}
                value={value}
                checked={checked}
                onChange={onChange}
                data-testid={`checkbox-${name}`}
            />
            <StyledCheckIcon />
        </CheckBoxContainer>
    );
};
